<template>
	<div class="bootomMenu">
		<div class="BottomMenu">
			<div class="itemTitle">Copyright © 2002-{{curTime}} financeun.com Inc. All rights reserved.</div>
			<div class="itemTitle">版权所有：中金网投（北京）资产管理有限公司 资产控股：亚洲金控投资有限公司 </div>
			<div class="itemTitle"  style="cursor: pointer;" @click="naviTo">京ICP备07028173号-3</div>
			<div class="itemTitle">网络文化经营许可证：京网文（2020）2658-436号 </div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				curTime: new Date().getFullYear()
			}
		},
		methods:{
			naviTo(){
				window.open('https://beian.miit.gov.cn/?spm=a2hja.14919748_WEBHOME_NEW.footer-container.5~5~5~5!4~A!3#/Integrated/index')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.BottomMenu {
		margin: 90px 0px 30px;

		.itemTitle {
			text-align: center;
			font-size: 12px;
			font-weight: 400;
			color: #E4E4E4;
		}
	}
</style>